import React from 'react';
import { FileText } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const isImage = (filename = '') => /\.(jpe?g|png|webp|gif)$/i.test(filename);
export const attachmentUrl = (doc) => doc.r2_public_url || `${BACKEND_URL}/api/documents/${doc.id}/file`;

/**
 * AttachmentPicker
 * Thumbnail-grid van documenten met checkbox om ze als mail-bijlage aan te vinken.
 * Klik op de thumbnail zelf => onPreview(doc) (grote popup viewer).
 * Props: documents, selectedIds, onToggle(docId), onPreview({url, filename}), testIdPrefix
 */
export const AttachmentPicker = ({ documents = [], selectedIds = [], onToggle, onPreview, testIdPrefix = 'attachment' }) => {
  if (documents.length === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testIdPrefix}-grid`}>
      {documents.map((doc) => {
        const checked = selectedIds.includes(doc.id);
        return (
          <div key={doc.id} className="relative" data-testid={`${testIdPrefix}-option-${doc.id}`}>
            {/* Checkbox overlay (linksboven) */}
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggle?.(doc.id)}
              onClick={(e) => e.stopPropagation()}
              className="absolute top-1.5 left-1.5 z-10 h-5 w-5 rounded border-gray-300 shadow cursor-pointer"
              data-testid={`${testIdPrefix}-checkbox-${doc.id}`}
            />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onPreview?.({ url: attachmentUrl(doc), filename: doc.filename });
              }}
              className={`w-full text-left focus:outline-none rounded-lg ${checked ? 'ring-2 ring-blue-500' : ''}`}
              title="Klik om groot te bekijken"
            >
              {isImage(doc.filename) && doc.r2_public_url ? (
                <img
                  src={doc.r2_public_url}
                  alt={doc.filename}
                  className="w-full h-20 object-cover rounded-lg border hover:opacity-90 transition-opacity"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-20 rounded-lg border bg-white flex flex-col items-center justify-center gap-1 hover:bg-gray-50 transition-colors">
                  <FileText className="w-6 h-6 text-red-500" />
                  <span className="text-[10px] text-gray-500 uppercase">
                    {(doc.filename || '').split('.').pop()}
                  </span>
                </div>
              )}
              <p className="text-[11px] truncate mt-0.5 text-gray-600" title={doc.filename}>
                {doc.filename}
              </p>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AttachmentPicker;
